import type { SidebarThreadArchiveControlProps } from "./SidebarThreadArchiveControl";
import type { ActivityCardContext } from "./ActivityThreadCard";

export function resolveActivityCardArchiveControl(
  context: ActivityCardContext,
): SidebarThreadArchiveControlProps | null {
  const { cardProps, state } = context;
  const archiveState = cardProps.thread.archive?.state ?? null;
  if (
    cardProps.thread.archivedAt !== null ||
    state.isThreadRunning ||
    archiveState === "requested" ||
    archiveState === "applying" ||
    archiveState === "archived"
  )
    return null;
  const actionLabel = archiveState === "failed" ? "Retry" : "Archive";
  if (state.isConfirmingArchive) {
    return {
      state: "confirming",
      threadId: cardProps.thread.id,
      title: cardProps.thread.title,
      confirmLabel: `Confirm ${actionLabel.toLowerCase()}`,
      confirmButtonRef: state.handleConfirmArchiveRef,
      onPointerDown: state.stopPropagationOnPointerDown,
      onConfirm: state.handleConfirmArchiveClick,
    };
  }
  return {
    state: "available",
    threadId: cardProps.thread.id,
    title: cardProps.thread.title,
    actionLabel,
    confirmBeforeArchive: cardProps.appSettingsConfirmThreadArchive,
    onPointerDown: state.stopPropagationOnPointerDown,
    onStartConfirmation: state.handleStartArchiveConfirmation,
    onArchiveImmediate: state.handleArchiveImmediateClick,
  };
}
